import get from 'lodash/get'
import remoteConfig from "@/mixins/remoteConfig";

export default {
  mixins: [remoteConfig],
  methods: {
    hasAccessToContent(themeId) {
      const masterclass= this.$store.getters.getThemeById(themeId)
      // const masterclass = this.$store.state.lesson.theme.byId[themeId]
      const isPremium = get(masterclass, 'premium', false)

      if (!isPremium || (this.$store.state.user.userInformations && this.$store.state.user.userInformations.roles && this.$store.state.user.userInformations.roles.includes('admin'))) {
        return true
      } else {
        let found = false
        // if it's a gift return false, if contentfulId == themeId return true
        Object.keys(this.$store.state.user.commands).forEach(commandId =>
          this.$store.state.user.commands[commandId].forEach(itemInCommand => {
            if ('properties' in itemInCommand && itemInCommand.properties.find(prop => prop.name === 'gift')) found = false
            else if (itemInCommand.contentfulId === themeId) found = true
          })
        )

        return found
      }
    },
    assertHasAccessToContent(themeId) {
      if (!this.hasAccessToContent(themeId)) {
        this.$router.push({
          name: 'shop-item',
          params: {
            type: 'masterclass',
            productId: themeId
          }
        })
      }

      // go through
    }
  }
}
